
































import Vue from 'vue';

const shareLinks = [
  {
    name: 'Facebook',
    icon: 'fab fa-facebook',
    getLink(url, text) {
      return `https://www.facebook.com/sharer.php?u=${encodeURIComponent(
        url
      )}&t=${encodeURIComponent(text)}`;
    },
  },
  {
    name: 'Linkedin',
    icon: 'fab fa-linkedin',
    getLink(url) {
      return `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
    },
  },
  {
    name: 'Twitter',
    icon: 'fab fa-twitter',
    getLink(url, text) {
      return `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        text + ' ' + url
      )}`;
    },
  },
  {
    name: 'Whatsapp',
    icon: 'fab fa-whatsapp',
    getLink(url, text) {
      return `https://api.whatsapp.com/send/?phone&text=${
        text + ' ' + url
      }&app_absent=0`;
    },
  },
  {
    name: 'Messenger',
    icon: 'fab fa-facebook-messenger',
    getLink() {
      return 'https://www.messenger.com/new';
    },
  },
  {
    name: 'Email',
    icon: 'far fa-envelope',
    getLink(url, text) {
      const subject = url;

      return `mailto:?body=${text}&subject=${subject}`;
    },
  },
];

export default Vue.extend({
  name: 'HMShareLinkModal',
  components: {},
  props: {
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      shareLinks,
    };
  },
  computed: {},
  methods: {
    copy(): void {
      this.$copyText(this.url).then(() => {
        this.$notify({
          group: 'app',
          type: 'success',
          text: this.$t('NOTIFICATIONS.TEXT.LINK_COPIED_TO_CLIPBOARD'),
        });
      });
    },
    openLink(shareLink) {
      window.open(shareLink.getLink(this.url, this.message), '_blank');
    },
  },
});
